import { SalesAddon } from '../../../models/reports/admin-report/sales-addon.model';
import {AbstractReportAdminPmsApiService} from "../abstract-report-admin.service";

/**
 * @class SalesAddonPmsApiService
 * @abstract
 * @extends {AbstractReportAdminPmsApiService<SalesAddon>}
 */
export class SalesAddonPmsApiService extends AbstractReportAdminPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/admin-reports/sales-addon';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {SalesAddon}
     * @protected
     */
    newModel(attributes, ...params) {

        return new SalesAddon(attributes);
    }

    /**
     * @param {Object=} params
     * @returns {Promise.<PaginationCollection<SalesAddon>>}
     */
    get(params = {}) {

        const url = this.url();

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/admin-report/sales-addon.service.js